import { t } from 'i18next'

import PageTitle from '~/components/PageTitle'
import CheckingAccountTable from '~/modules/retailMedia/components/CheckingAccountTable'
import styles from '~/modules/retailMedia/components/CheckingAccountTable/styles.module.css'

const WalletsList = () => {
  return (
    <div className={styles.shell}>
      <PageTitle title={t('rm:wallet.page.title')} />

      <header className={styles.headerPage}>
        <h1 className={styles.headerTitle}>{t('rm:Wallets')}</h1>
        <p className={styles.headerSub}>{t('rm:wallet.list.subtitle')}</p>
      </header>

      <CheckingAccountTable />
    </div>
  )
}

export default WalletsList
